import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var TextContainer = function TextContainer(_ref) {
  var title = _ref.title,
    description = _ref.description;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('container')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('title')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size2-b"
  }, title)), /*#__PURE__*/React.createElement(Text, {
    size: "size5-m"
  }, description));
};
TextContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string,
  description: PropTypes.string
} : {};